<template><v-btn color="primary" style="padding:10px;font-size:27px;" @click="handleClick">Starta&nbsp;Solarium&nbsp;Karlskoga</v-btn>
</template>
<script>export default {
  methods: {
    handleClick() {
      fetch('https://shelly-45-eu.shelly.cloud/device/relay/control', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: new URLSearchParams({
          'turn': 'on',
          'channel': '0',
          'id': 'c82e1892a32c',
          'auth_key': 'MTI5ZDMxdWlkAEBF4812C4AFE5E53F48824924A02B85B0D5034D915610411BB05FBBFBA3B6347101E7706B0C1392'
        })
      })
      .then(response => response.text())
      .then(data => console.log(data))
      .catch(error => console.error('Error:', error));
    }
  }
} </script>